import { getID } from "src/libs/utilities";

export default function accordeon(): any[] {
    return [
        {
            id: getID("accordeon"),
            title: "Gradient",
            cover_width: 100,
            "cardColors": ["#ea848e", "#112c99"], 
            "isNoBackground": false, 
            "label_size": 22,
            "card_label": {
                "letterSpacing": "1px",
                "textTransform": "upperCase", 
                "alignItems": "flex-end"
            },
            "card": { },
            "card_cover": { },
            "card_icon": { }
        }, 
        {
            id: getID("accordeon"),
            title: "Minimal",
            isNoBackground: true,  
            "label_size": 22,
            "card_label": {
                "letterSpacing": "4px",
                "textTransform": "upperCase", 
                "alignItems": "flex-end"
            },
            "card": { },
            "card_cover": { },
            "card_icon": { }
        }, 
        {
            id: getID("accordeon"),
            title: "Light folders",
            isNoBackground: true,  
            "cover_width": 40,
            "isOrder": 0, 
            "label_size": 14,
            "icon_size": 17,
            "card_label": {
                "letterSpacing": "4px",
                "textTransform": "upperCase",
                "alignItems": "flex-end",
                "fontWeight": 500
            },
            "card": {
                "borderBottom": "1px solid var(--force-contrast-secondary-opacity-color)",
            },
            "card_cover": {},
            "card_icon": {}, 
        }, 
        {
            id: getID("accordeon"),
            title: "Modern light",
            "isNoBackground": true,
            "cover_width": 50,
            "icon_size": 40,
            "isOrder": 0,
            "label_size": 45,
            "card_label": {
                "letterSpacing": "4px",
                "textTransform": "upperCase",
                "fontWeight": 100,
                "alignItems": "flex-end"
            },
            "card": {
                "margin": "0 8px", 
                "borderBottom": "1px dotted var(--force-contrast-opacity-color)",
                "backgroundColor": "transparent"
            },
            "card_cover": {},
            "card_icon": {},  
        }, 
        {
            id: getID("accordeon"),
            title: "Jeans",
            "cover_width": 100,
            "isOrder": 0,
            "isNoBackground": 0,
            "label_size": 24,
            "icon_size": 20,
            "cardColors": ["#362879", "#8478bb"],
            "card_label": {
            "letterSpacing": "1px",
            "textTransform": "upperCase",
            "alignItems": "flex-end",
            "fontWeight": 500
            },
            "card": {
                "outline": "3px dashed var(--force-plain-color)",
                "outlineOffset": "-7px",
                "marginLeft": "8px",
                "marginRight": "8px",
                "borderRadius": "75px"
            },
            "card_cover": { "borderRadius": 35 },
            "card_icon": {
                "backgroundColor": "#0ecda4",
                "padding": "15px",
                "width": "50px",
                "height": "50px",
                "marginRight": "10px",
                "borderRadius": "50px",
                "color": "#FFFFFF"
            },
        }, 
        {
            id: getID("accordeon"),
            title: "Red gold",
            "cover_width": 100,
            "isOrder": 0,
            "isNoBackground": false,
            "label_size": 62,
            "cardColors": ["#9d0000", "#ebb038"],
            "card_label": {
                "letterSpacing": "1px",
                "textTransform": "upperCase",
                "alignItems": "flex-end",
                "fontWeight": 700
            },
            "card": {},
            "card_cover": {},
            "card_icon": {}, 
        }, 
        {
            id: getID("accordeon"),
            title: "Hotdogs",
            "cover_width": 100,
            "isOrder": 0,
            "isNoBackground": 0,
            "label_size": 24,
            "cardColors": ["#9d0000", "#ebb038"],
            "card_label": {
            "letterSpacing": "1px",
            "textTransform": "upperCase",
            "alignItems": "flex-end",
            "fontWeight": 500
            },
            "card": {
            "outline": "1px dotted var(--force-plain-color)",
            "outlineOffset": "-5px",
            "marginTop": "8px",
            "marginBottom": "8px",
            "borderRadius": "75px"
            },
            "card_cover": { "borderRadius": "35px" },
            "card_icon": { "marginRight": "20px" }
        }, 
        {
            id: getID("accordeon"),
            title: "Pitaya",
            "isNoBackground": true,
            "cover_width": 40,
            "isOrder": 0,
            "label_size":9,
            "icon_size": 8,
            "card_label": {
                "letterSpacing": "4px",
                "textTransform": "upperCase",
                "alignItems": "flex-end",
                "fontWeight": 100
            },
            "card": {
                "borderBottom": "1px solid var(--force-contrast-secondary-opacity-color)"
            },
            "card_cover": {},
            "card_icon": {} 
        }, 
        {
            id: getID("accordeon"),
            title: "Jnt capsule",
            "isNoBackground": true,
            "cover_width": 40,
            "isOrder": 0,
            "label_size":14,
            "icon_size": 13,
            "container": {
            "background": "var(--force-plain-color)",
            "marginBottom": "3px",
            "borderRadius": "20px",
            "overflow": "hidden",
            "border": "1px solid #1abc9c"
            },
            "card_label": {
            "letterSpacing": "2px",
            "color": "var(--force-plain-color)",
            "textTransform": "upperCase",
            "alignItems": "flex-end",
            "fontWeight": 100
            },
            "card": {
            
            },
            "card_cover": {
            "backgroundColor": "#1abc9c"
            },
            "card_icon": {
            "marginRight": 0
            },
            "content_container": {
            "padding": "0 20px"
            } 
        },
        {
            id: getID("accordeon"),
            title: "Capsule",            
            "isNoBackground": true,
            "cover_width": 40,
            "isOrder": 0,
            "label_size":14,
            "icon_size": 13,
            "container": {
            "background": "var(--force-plain-color)",
            "marginBottom": "5px",
            "borderRadius": "20px",
            "overflow": "hidden" 
            },
            "card_label": {
            "letterSpacing": "2px", 
            "textTransform": "upperCase",
            "alignItems": "flex-end",
            "fontWeight": 100
            },
            "card": {
            
            },
            "card_cover": { 
            },
            "card_icon": {
            "marginRight": 0
            },
            "content_container": {
            "padding": "0 20px"
            }  
        },  
    ]
}